export const environment = {
  apiBaseUrl: 'https://api-dev.kochikachar-bornomala.de/',
};
